module.exports = __webpack_public_path__ + "static/media/frown-regular-active.cba7aaad.svg";